import React from 'react';
import { Award, Mail, Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gradient-to-br from-orange-400 to-red-500 p-2 rounded-lg">
                <Award className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold">Youth Baseball</h3>
                <p className="text-sm text-gray-400">Skills & Drills</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Helping young players develop their baseball skills through expert-designed exercises and drills.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-orange-400">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  Home
                </a>
              </li>
              <li>
                <a href="/exercises" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  Exercise Library
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-orange-400">Get in Touch</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-sm text-gray-400">
                <Mail className="h-5 w-5 text-orange-400" />
                <span>contact@youthbaseball.com</span>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed">
                Have questions or suggestions? We'd love to hear from you!
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © 2024 Youth Baseball Skills & Drills. All rights reserved.
          </p>
          <div className="flex items-center space-x-1 text-sm text-gray-400 mt-4 md:mt-0">
            <span>Made with</span>
            <Heart className="h-4 w-4 text-red-500 fill-current" />
            <span>for young athletes</span>
          </div>
        </div>
      </div>
    </footer>
  );
};